import styled from "styled-components";

export const DefinitionWrapper = styled.div`
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  break-inside: avoid;
  margin-bottom: ${({ theme }) => theme.space.sm};
`;
